$(() => {
    initFunctions();
});

function initFunctions() {
    initMobileTopHamburgerMenu();
    initMobileBottomMenu();
    initMobileLanguageSelector();
}

function initMobileBottomMenu() {
    let menu = $('.mobile-bar-menu');
    let trigger = $('#toggle-mobile-menu .toggle-mobile-menu');

    if (!trigger[0])
        return;
    
    trigger = $('#toggle-mobile-menu');
    let extraItems = ['body', '#toggle-mobile-menu'];
    // toggleMenu(menu, activeClass = 'open', extraItems);
    trigger.on('click', () => {
        toggleMenu(menu, activeClass = 'open', extraItems);
    });
}

function toggleMenu(menu, activeClass, extraItems, forceState = '') {
    if (menu.hasClass(activeClass)) {
        menu.removeClass(activeClass);
        $.each(extraItems, function(index, value) {
            $(value).removeClass(activeClass);
        });
    } else {
        menu.addClass(activeClass);
        $.each(extraItems, function(index, value) {
            $(value).addClass(activeClass);
        });
    }
}

function initMobileTopHamburgerMenu() {
    let trigger = $('#trigger-mobile-hamburger-menu, #close-hamburger-menu');
    let menu = $('.mobile-hamburger-menu');

    if (!trigger[0])
        return;

    let extraItems = ['body', '#trigger-mobile-hamburger-menu'];
    trigger.on('click', () => {
        toggleMenu(menu, activeClass = 'openHamburger', extraItems);
    });
    
    let menuOverlay = $('.hamburger-menu-overlay');
    menuOverlay.on('click', () => {
        toggleMenu(menu, activeClass = 'openHamburger', extraItems);
    });

    
    /* Temp function */
    // trigger.trigger('click');
    /* End temp function */
}

function initMobileLanguageSelector() {
    let trigger = $('#translate-selector-mobile');
    let menu = $('#translate-selector-mobile .languages');

    if (!trigger[0])
        return;

    let extraItems = ['.hamburger-menu-wrapper'];
    trigger.on('click', () => {
        toggleMenu(menu, activeClass = 'showOptions', extraItems);
    });
}
